import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';

import { GetSavedSearchDocument, GetSavedSearchQuery, GetSavedSearchQueryVariables } from './savedSearches.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

const defaultOptions = { client: apolloClientContracts } as const;

export function useGetSavedSearchLazyQuery(
  baseOptions?: LazyQueryHookOptions<
  GetSavedSearchQuery,
  GetSavedSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useLazyQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(
    GetSavedSearchDocument,
    options,
  );
}